export default __webpack_public_path__ + "static/media/kwid-small.c0044aa3.jpg";